module.exports = __webpack_public_path__ + "static/mobile-final-3-up-3.41c8d4bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/mobile-final-3-up-3.jpg
// module id = ./src/pages/mobile-final-3-up-3.jpg
// module chunks = 100945961233241